export default __webpack_public_path__ + "static/media/miguel-lopes-30.80c35d98.jpg";